module.exports = __webpack_public_path__ + "img/Uni-pro-shop-bumpertobumper.bc518210.jpg";